import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AmericanFlagLogo from "./../../Assets/Images/american_flag.png";
import { makeStyles } from "@material-ui/core/styles";

// MUI ICONS (replacing Font Awesome)
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SendIcon from '@mui/icons-material/Send';



const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "auto",
        color: "#eceff1",
        backgroundColor: "#2c5aa0",
        position: "relative",
        boxShadow: '0px -3px 6px rgba(0,0,0,0.12)',
    },
    customerCommentGridItm: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRight: "1px solid #3771c8",
        [theme.breakpoints.down("md")]: { border: "none" },
        [theme.breakpoints.down("sm")]: { display: "none" },
    },
    referenceBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: 300,
        textAlign: "center",
        fontWeight: 400,
        color: "#efefef",
        fontFamily: "auto",
        padding: "0 20%",
        [theme.breakpoints.down("md")]: { width: 775, textAlign: "center" },
        [theme.breakpoints.down("sm")]: { width: 635 },
        [theme.breakpoints.down("xs")]: { textAlign: "left", padding: "0 12%", fontSize: 15 },
    },
    reference: {
        fontFamily: "auto",
        fontSize: '1.2em',
        lineHeight: 1.3,
        marginTop: 15,
    },
    signatureCon: {
        height: 30,
        textAlign: "right",
        width: "100%",
        marginTop: 10,
        fontFamily: "auto",
        fontSize: 17,
        color: "#efefef",
        [theme.breakpoints.down("md")]: { textAlign: "right" },
        [theme.breakpoints.down("xs")]: { marginTop: 5, fontSize: 16 },
    },
    signature: { fontFamily: "auto", display: "inline" },
    stars: { color: "#fbe46a", fontSize: 16, marginLeft: 5, display: "inline" },
    aboutMeCardGridItm: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderLeft: "1px solid #3771c8",
        [theme.breakpoints.down("md")]: { border: "none", alignItems: "unset" },
        [theme.breakpoints.down("sm")]: { marginTop: 40 },
        [theme.breakpoints.down("xs")]: {
            marginTop: 0,
            padding: "0 0 10% 0",
            borderLeft: "none",
            borderTop: "none",
        },
    },
    cardBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        height: 300,
        textAlign: "left",
        color: "#efefef",
        fontFamily: "auto",
        paddingLeft: 40,
        [theme.breakpoints.down("xs")]: { padding: "2%", textAlign: "center" },
    },
    copyrightGridItm: {
        backgroundColor: "#2c5aa0",
        borderTop: "2px solid #3771c8",
        height: 60,
        width: "100%", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: { marginTop: 90 },
        [theme.breakpoints.down("xs")]: { height: 60, marginTop: -50 },
    },
    copyrightSig: {
        color: "#dee0e1ff",
        fontSize: 14,
        fontFamily: "monospace",
        [theme.breakpoints.down("xs")]: { fontSize: 12 },
    },
    infoLine: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10,
        fontSize: 18,
    },
    infoIcon: {
        marginRight: 12,
        fontSize: 20,
    },
    infoText: { 
        fontSize: '1em',
        [theme.breakpoints.down("sm")]: { fontSize: '.9em' },
    },
    companyLogo: {
        width: 240,
        display: "block",
        margin: "0 auto 24px auto",
        [theme.breakpoints.down("xs")]: { width: 200, marginTop: -50, marginBottom: 20 },
    },
}));

const Footer = (props) => {
    const classes = useStyles();

    return (
        <>
            {/* ROOT GRID NOW HAS position: relative */}
            <Grid container className={classes.root}>
                {/* Left side */}
                <Grid item xs={12} md={6} className={classes.customerCommentGridItm}>
                    <Box className={classes.referenceBox}>
                        <Typography className={classes.reference}>
                            Chinook Water Testing provides certified well water sampling, real-estate transaction testing, flow-rate (GPM) testing, and non-invasive system inspections throughout North Idaho and Eastern Washington. We partner with state-certified labs to deliver accurate, fast results you can rely on.
                        </Typography>
                        <Box className={classes.signatureCon}>
                            <Typography className={classes.signature} component="span">
                                — Google Reviews
                            </Typography>
                            <span className={classes.stars}>★★★★★</span>
                        </Box>
                    </Box>
                </Grid>

                {/* Right side */}
                <Grid item xs={12} md={6} className={classes.aboutMeCardGridItm}>
                    <Box className={classes.cardBox}>

                        {/* Service Area */}
                        <Box className={classes.infoLine}>
                            <LocationOnIcon className={classes.infoIcon} />
                            <Typography className={classes.infoText}>
                                Serving North Idaho & Eastern WA
                            </Typography>
                        </Box>

                        {/* Email */}
                        <Box className={classes.infoLine}>
                            <MailOutlineIcon className={classes.infoIcon} />
                            <Typography className={classes.infoText}>
                                <a href="mailto:chinookwatertesting@gmail.com" style={{ color: "#efefef", textDecoration: "none"}}>
                                    chinookwatertesting@gmail.com
                                </a>
                            </Typography>
                        </Box>

                        {/* Phone */}
                        <Box className={classes.infoLine}>
                            <PhoneIcon className={classes.infoIcon} />
                            <Typography className={classes.infoText}>
                                <a href="tel:+12083523909" style={{ color: "#efefef", textDecoration: "none" }}>
                                    +1 (208) 352-3909
                                </a>
                            </Typography>
                        </Box>

                        {/* Get a Quote Now */}
                        <Box className={classes.infoLine} style={{ marginBottom: 0 }}>
                            <SendIcon className={classes.infoIcon} />
                            <Typography className={classes.infoText}>
                                <a href="/contact" style={{ color: "#efefef", textDecoration: "underline" }}>
                                    Get a Quote Now
                                </a>
                            </Typography>
                        </Box>

                    </Box>
                </Grid>

                {/* Bottom bar — no inline style needed anymore */}
                <Grid item className={classes.copyrightGridItm}>
                    <Box className={classes.copyrightSig}>
                        <img
                            src={AmericanFlagLogo}
                            alt="American Flag Logo"
                            style={{ height: "1.5em", verticalAlign: "middle" }}
                        />{" "}
                        U.S. Veteran Owned and Operated © {new Date().getFullYear()}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

Footer.propTypes = {
    location: PropTypes.object,
};

export default Footer;